import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface DocumentCardSkeletonProps {
  count?: number;
  className?: string;
  showBorder?: boolean;
}

const DocumentCardSkeleton = ({
  count = 3,
  className,
  showBorder = true,
}: DocumentCardSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            styles.wrapperSkeleton,
            showBorder && styles.leftBorder,
            className,
          )}
        >
          <div className={styles.iconWrapSkeleton}>
            <SkeletonLoader className={styles.iconSkeleton} />
          </div>

          <div className={styles.contentSkeleton}>
            <div className={styles.titleRowSkeleton}>
              <SkeletonLoader className={styles.titleSkeleton} />
              <SkeletonLoader className={styles.badgeSkeleton} />
            </div>

            <div className={styles.metaSkeleton}>
              <SkeletonLoader className={styles.metaItemSkeleton} />
              <SkeletonLoader className={styles.metaItemSkeleton} />
              <SkeletonLoader className={styles.metaItemSkeleton} />
            </div>
          </div>

          <div className={styles.buttonSkeleton}>
            <SkeletonLoader className={styles.button} />
          </div>
        </div>
      ))}
    </>
  );
};

export default DocumentCardSkeleton;
